import React from 'react';
import { FilterPanelProps, ButtonConfig } from '../../types/components/filters/FilterTypes';

export const wrapperClass = 'flex flex-col md:flex-row gap-3 mb-5 md:mb-0';
export const selectedClass =
  'flex border !border-blue-800 bg-blue-1000 bg-opacity-20 text-white cursor-pointer !hover:bg-blue-1000 !hover:bg-opacity-20 ';
export const typeClass =
  'flex gap-2 items-center border border-gray-700 rounded-[5px] px-4 py-3 text-gray-600 font-500 text-[14px] md:text-[10px] lg:text-[14px] cursor-pointer';
export const spanClass = 'mt-[1px] md:hidden lg:flex text-[12px]';
export const hoverClass =
  'hover:border hover:border-[#4D5457] hover:bg-white hover:bg-opacity-5 cursor-pointer';

export const DynamicFilterButtons: React.FC<FilterPanelProps> = ({
  activeFilter,
  setFilter,
  buttonsConfig
}) => {
  const getButtonClass = (category) => {
    return `${
      activeFilter?.toLowerCase() === category?.toLowerCase()
        ? selectedClass + typeClass
        : typeClass + hoverClass
    }`;
  };
  return (
    <div cy-test-id="filterButtonGroup" className={wrapperClass}>
      {buttonsConfig.map(
        ({ category, label, IconComponent, total, link, href }) =>
          (total === null || total > 0) &&
          (link ? (
            <a
              key={category}
              href={href}
              className={getButtonClass(category)}
              style={{ textDecoration: 'none' }}>
              {IconComponent && <IconComponent cy-test-id={`${category}-icon`} />}
              {label}
              {total !== null && <span className={spanClass}>{total}</span>}
            </a>
          ) : (
            <button
              key={category}
              className={getButtonClass(category)}
              onClick={() => setFilter(category)}>
              {IconComponent && <IconComponent cy-test-id={`${category}-icon`} />}
              {label}
              {total !== null && <span className={spanClass}>{total}</span>}
            </button>
          ))
      )}
    </div>
  );
};
